import Container = PIXI.Container;
import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import TextStyle = PIXI.TextStyle;
import { createSprite, translate } from '../../utils/GameEngine';
import { TextStyles } from '../../utils/TextStyles';
import { Button } from '../../UI/elements/buttons/Button';
import { degToRad } from '../../utils/MathUtils';

export class MovesBubble extends Button {
  private icon: PIXI.Sprite;

  constructor(buyFunction: () => any, enoughCoins: boolean, parent?: Container) {
    super('pink_btn_small@2x', buyFunction, null, true, true, 1);
    if (parent) {
      parent.addChild(this);
    }
    this.drawElements(enoughCoins);
    this.enable();
  }

  protected drawLayout(): void {
    super.drawLayout();
  }

  private drawElements(enoughCoins: boolean): void {
    this.icon = createSprite('moves_icon@2x', this);
    this.icon.anchor.set(0.5, 0.5);
    this.icon.position.set(this.icon.width / 2, this.defaultSkin.height / 2);

    let movesToAdd: number = 10;
    if (!enoughCoins) {
      movesToAdd = 15;
    }

    const movesText: Text = new PIXI.Text('+' + movesToAdd, TextStyles.smallTextWhite);
    movesText.anchor.set(0.5, 0.5);
    movesText.position.set(this.icon.x, this.icon.y - 5);
    this.addChild(movesText);

    if (enoughCoins) {
      const coinsAmount: Text = new PIXI.Text('2000', TextStyles.uiText);
      coinsAmount.anchor.set(0, 0.5);
      coinsAmount.position.set(this.icon.width + 6, this.icon.y - 5);
      this.addChild(coinsAmount);

      const coinsSprite: Sprite = createSprite('coin_icon@2x', this);
      coinsSprite.anchor.set(0, 0.5);
      coinsSprite.position.set(coinsAmount.x + coinsAmount.width + 4, this.icon.y);
    } else {
      const style1: TextStyle = TextStyles.uiText.clone();
      style1.fontSize = '24px';
      const watchText: Text = new PIXI.Text(translate('Watch', true) + '!', style1);
      watchText.anchor.set(0, 0.5);
      watchText.position.set(this.icon.width + 6, this.icon.y - 5);
      this.addChild(watchText);
    }

    this.pivot.set(this.defaultSkin.width / 2, this.defaultSkin.height / 2);
    this.interactive = false;
    this.buttonMode = false;
  }

  public disable(): void {
    this.interactive = false;
    this.buttonMode = false;
  }

  public onLoading(): void {
    this.disable();
    this.icon.visible = false;
    const loadingIcon: Sprite = createSprite('loading_donut', this);
    loadingIcon.anchor.set(0.5, 0.5);
    loadingIcon.scale.set(0.3, 0.3);
    loadingIcon.position.set(this.icon.position.x, this.icon.position.y);
    TweenMax.to(loadingIcon, 1, {
      rotation: degToRad(720),
      repeat: -1
    });
  }
}